import React from 'react';
import { styled } from '@mui/material';

import { Button, Checkbox, Divider, IconButton, Radio, RadioGroup, Stack, Text } from 'shell/components';
import { useUser2 } from 'contexts/user2';

const FilterSortPeerEvaluationTableInstructor = ({
    sortKey,
    filterKey,
    onClick: handleClick,
    onClose: handleClose,
    resetFilterSort,
}) => {
    return (
        <Stack>
            <IconButton
                sx={{ alignSelf: 'flex-end' }}
                kind={'exit'}
                size={'medium'}
                variant={'square'}
                onClick={handleClose}
            />
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text variant={'h6'} weight={'semibold'}>
                    Sort By
                </Text>
                <Button variant={'tertiary'} onClick={resetFilterSort}>
                    Reset All
                </Button>
            </Stack>
            <Stack>
                <CustomRadioGroup
                    value={sortKey.peerEvaluationTable}
                    onChange={(_, value) => handleClick('SORT', value)}
                >
                    <Radio label={'Closet Due'} labelPlacement={'start'} value={'closestDue'} />
                    <Radio label={'Furthest Due'} labelPlacement={'start'} value={'furthestDue'} />
                    <Radio label={'Title A-Z'} labelPlacement={'start'} value={'titlea-z'} />
                    <Radio label={'Title Z-A'} labelPlacement={'start'} value={'titlez-a'} />
                </CustomRadioGroup>
            </Stack>
            <Divider sx={{ margin: '24px 0px' }} />
            <Text variant={'h6'} weight={'semibold'}>
                Filters
            </Text>
            <CustomText color={'light'} variant={'p1'}>
                Status
            </CustomText>
            <CustomStack>
                <Checkbox
                    checked={filterKey.status.includes('published')}
                    label={'Published'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'published')}
                />
                <Checkbox
                    checked={filterKey.status.includes('scheduled')}
                    label={'Scheduled'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'scheduled')}
                />
                <Checkbox
                    checked={filterKey.status.includes('draft')}
                    label={'Saved as Draft'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'draft')}
                />
            </CustomStack>
            <CustomText color={'light'} variant={'p1'}>
                Due Date
            </CustomText>
            <CustomStack>
                <Checkbox
                    checked={filterKey.dueDate.includes('today')}
                    label={'Today'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'today')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('thisweek')}
                    label={'This Week'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'thisweek')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('nextweek')}
                    label={'Next Week'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'nextweek')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('overdue')}
                    label={'Overdue'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'overdue')}
                />
            </CustomStack>
        </Stack>
    );
};

const FilterSortSubmissionTableInstructor = ({
    sortKey,
    filterKey,
    onClick: handleClick,
    onClose: handleClose,
    resetFilterSort,
}) => {
    const { groups } = useUser2();
    return (
        <Stack>
            <IconButton
                sx={{ alignSelf: 'flex-end' }}
                kind={'exit'}
                size={'medium'}
                variant={'square'}
                onClick={handleClose}
            />
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text variant={'h6'} weight={'semibold'}>
                    Sort By
                </Text>
                <Button variant={'tertiary'} onClick={resetFilterSort}>
                    Reset All
                </Button>
            </Stack>
            <Stack>
                <CustomRadioGroup value={sortKey.submissionTable} onChange={(_, value) => handleClick('SORT', value)}>
                    <Radio label={'Last Name A-Z'} labelPlacement={'start'} value={'lastNamea-z'} />
                    <Radio label={'Last Name Z-A'} labelPlacement={'start'} value={'lastNamez-a'} />
                    <Radio label={'Complete'} labelPlacement={'start'} value={'complete'} />
                    <Radio label={'Incomplete'} labelPlacement={'start'} value={'incomplete'} />
                    <Radio label={'Submitted Earliest'} labelPlacement={'start'} value={'submittedEarliest'} />
                    <Radio label={'Submitted Latest'} labelPlacement={'start'} value={'submittedLatest'} />
                </CustomRadioGroup>
            </Stack>
            <Divider sx={{ margin: '24px 0px' }} />
            <Text variant={'h6'} weight={'semibold'}>
                Filters
            </Text>
            <CustomText color={'light'} variant={'p1'}>
                Team
            </CustomText>
            <CustomStack>
                {groups.map((group) => {
                    return (
                        <Checkbox
                            checked={filterKey.groups.includes(group.id)}
                            label={group.name}
                            labelPlacement={'start'}
                            onChange={() => handleClick('GROUPS', group.id)}
                        />
                    );
                })}
            </CustomStack>
        </Stack>
    );
};

const FilterSortPeerEvaluationTableStudent = ({
    sortKey,
    filterKey,
    onClick: handleClick,
    onClose: handleClose,
    resetFilterSort,
}) => {
    return (
        <Stack>
            <IconButton
                sx={{ alignSelf: 'flex-end' }}
                kind={'exit'}
                size={'medium'}
                variant={'square'}
                onClick={handleClose}
            />
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text variant={'h6'} weight={'semibold'}>
                    Sort By
                </Text>
                <Button variant={'tertiary'} onClick={resetFilterSort}>
                    Reset All
                </Button>
            </Stack>
            <Stack>
                <CustomRadioGroup
                    value={sortKey.peerEvaluationTable}
                    onChange={(_, value) => handleClick('SORT', value)}
                >
                    <Radio label={'Closet Due'} labelPlacement={'start'} value={'closestDue'} />
                    <Radio label={'Furthest Due'} labelPlacement={'start'} value={'furthestDue'} />
                    <Radio label={'Title A-Z'} labelPlacement={'start'} value={'titlea-z'} />
                    <Radio label={'Title Z-A'} labelPlacement={'start'} value={'titlez-a'} />
                    <Radio label={'Submitted'} labelPlacement={'start'} value={'submitted'} />
                    <Radio label={'Not Submitted'} labelPlacement={'start'} value={'notSubmitted'} />
                </CustomRadioGroup>
            </Stack>
            <Divider sx={{ margin: '24px 0px' }} />

            <Text variant={'h6'} weight={'semibold'}>
                Filters
            </Text>
            <CustomText color={'light'} variant={'p1'}>
                Due Date
            </CustomText>
            <CustomStack>
                <Checkbox
                    checked={filterKey.dueDate.includes('today')}
                    label={'Today'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'today')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('thisweek')}
                    label={'This Week'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'thisweek')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('nextweek')}
                    label={'Next Week'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'nextweek')}
                />
                <Checkbox
                    checked={filterKey.dueDate.includes('overdue')}
                    label={'Overdue'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('DUEDATE', 'overdue')}
                />
            </CustomStack>
            <CustomText color={'light'} variant={'p1'}>
                Status
            </CustomText>
            <CustomStack>
                <Checkbox
                    checked={filterKey.status.includes('open')}
                    label={'Open'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'open')}
                />
                <Checkbox
                    checked={filterKey.status.includes('locked')}
                    label={'Locked'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'locked')}
                />
                <Checkbox
                    checked={filterKey.status.includes('closed')}
                    label={'Closed'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'closed')}
                />
            </CustomStack>
        </Stack>
    );
};

const FilterSortPeerEvaluationsWrapper = ({
    type,
    role,
    sortKey,
    statusKey,
    dueDateKey,
    filterKey,
    onClick: handleClick,
    onClose: handleClose,
    resetFilterSort,
}) => {
    const props = {
        sortKey,
        statusKey,
        dueDateKey,
        filterKey,
        onClick: handleClick,
        onClose: handleClose,
        resetFilterSort,
    };

    const FILTERS = {
        instructor: {
            peerEvaluationTable: <FilterSortPeerEvaluationTableInstructor {...props} />,
            submissionTable: <FilterSortSubmissionTableInstructor {...props} />,
        },
        student: {
            peerEvaluationTable: <FilterSortPeerEvaluationTableStudent {...props} />,
        },
    };

    return FILTERS[role][type];
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 1),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        paddingLeft: theme.spacing(2),
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default FilterSortPeerEvaluationsWrapper;
